/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { NavigationMenuModelDto, UpdateSsoUserInstitutionModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class NavigationsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Navigations
   * @name NavigationsGet
   * @summary Gets navigation menu.
   * @request GET:/navigations
   */
  navigationsGet = (params: RequestParams = {}) =>
    this.http.request<NavigationMenuModelDto, any>({
      path: `/navigations`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Navigations
   * @name NavigationsUpdateInstitution
   * @summary Update institution.
   * @request POST:/navigations/UpdateInstitution/{institutionId}
   */
  navigationsUpdateInstitution = (
    institutionId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<UpdateSsoUserInstitutionModelDto, any>({
      path: `/navigations/UpdateInstitution/${institutionId}`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Navigations
   * @name NavigationsAuditMenulessUserActivity
   * @summary Save menu user activity.
   * @request POST:/navigations/AuditMenulessUserActivity/{menulessNavigationId}
   */
  navigationsAuditMenulessUserActivity = (
    menulessNavigationId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/navigations/AuditMenulessUserActivity/${menulessNavigationId}`,
      method: "POST",
      ...params,
    });
  /**
   * No description
   *
   * @tags Navigations
   * @name NavigationsAuditUserActivity
   * @summary Save audit user activity
   * @request POST:/navigations/auditUserActivity/{navigationKey}
   */
  navigationsAuditUserActivity = (
    navigationKey: string,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/navigations/auditUserActivity/${navigationKey}`,
      method: "POST",
      ...params,
    });
}
